import { CreateNewApplicationTab } from '../Search/CreateNewApplicationTab';
import styles from './CreateApplication.module.css';

export function CreateApplication() {
  return (
    <div className={styles.root}>
      <CreateNewApplicationTab />
    </div>
  );
}
